import { render, staticRenderFns } from "./CheckboxGlobal.vue?vue&type=template&id=3ce0faa0&scoped=true&"
import script from "./CheckboxGlobal.vue?vue&type=script&lang=js&"
export * from "./CheckboxGlobal.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGlobal.vue?vue&type=style&index=0&id=3ce0faa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0faa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
